// This file is dynamically generated
type LocaleData = Record<LocaleKeys, string>;
import { type Locales, LocaleKeys } from './types';
const CACHE: Partial<Record<Locales, LocaleData>> = {};
const locales = [
  {
    "code": "af",
    "hash": "a0f076339d8da6ddfaff27769928d414",
    "name": "Afrikaans"
  },
  {
    "code": "ar",
    "hash": "47f82bd73d0d248e7edd924bcea1e341",
    "name": "العربية"
  },
  {
    "code": "bg",
    "hash": "0b90285b73e35715d9306423264194c8",
    "name": "Български"
  },
  {
    "code": "bn",
    "hash": "aa188fc15cb8be5cfcdb95c1e7d18025",
    "name": "বাংলা"
  },
  {
    "code": "bs",
    "hash": "df5713a2a8f86cf7499583b1c8575820",
    "name": "Bosanski"
  },
  {
    "code": "ca",
    "hash": "9e4979937070edb93be05ff5b6cac8cb",
    "name": "Català"
  },
  {
    "code": "cs",
    "hash": "f9dc651353b0b2ecb1adbe2b92f5cc01",
    "name": "Čeština"
  },
  {
    "code": "cy",
    "hash": "f6faf915421db6dd1d39b70be45a8e54",
    "name": "Cymraeg"
  },
  {
    "code": "da",
    "hash": "263ca3a50b0cd2f43472e0cb57ef5f80",
    "name": "Dansk"
  },
  {
    "code": "de",
    "hash": "4b920fc7c58aa42d9603117aa71b9a61",
    "name": "Deutsch"
  },
  {
    "code": "el",
    "hash": "d6de69aa7e1c7e07a3ca2af3cdba9c57",
    "name": "Ελληνικά"
  },
  {
    "code": "en",
    "hash": "f44c6fb1abaaeacf587fa122f38e0a35",
    "name": "English"
  },
  {
    "code": "en-GB",
    "hash": "eeb99ff4b9c997a0c0a99306cca6243b",
    "name": "English (GB)"
  },
  {
    "code": "eo",
    "hash": "0de839e3ad3e3189ec37160fe540c75e",
    "name": "Esperanto"
  },
  {
    "code": "es",
    "hash": "3fc8453548402180bca5d5d32473762d",
    "name": "Español"
  },
  {
    "code": "es-419",
    "hash": "5898b9c0e228624152a5ff77b1ffa097",
    "name": "Español (Latin America)"
  },
  {
    "code": "et",
    "hash": "38bf32a6ed529efe3f2d2f9e3f8b9c41",
    "name": "Eesti"
  },
  {
    "code": "eu",
    "hash": "209289e6245240e0e1947346f86233f7",
    "name": "Euskara"
  },
  {
    "code": "fa",
    "hash": "3c5c2ce234df8011e6459ece93c27655",
    "name": "فارسی"
  },
  {
    "code": "fi",
    "hash": "be1cec524da9d80f4e92a6aa97e82a6e",
    "name": "Suomi"
  },
  {
    "code": "fy",
    "hash": "353b0354181447d4299a065b8bd40814",
    "name": "Frysk"
  },
  {
    "code": "fr",
    "hash": "8e52d097a63fb73aa3d0f27d2836bfe0",
    "name": "Français"
  },
  {
    "code": "ga",
    "hash": "ad525e2c76d18b24e752bf3c697d6665",
    "name": "Gaeilge"
  },
  {
    "code": "gl",
    "hash": "06ac0757b8866d60e1099a1a70a51a83",
    "name": "Galego"
  },
  {
    "code": "gsw",
    "hash": "1fc73e115507ad1aceadbd099405b12c",
    "name": "Schwiizerdütsch"
  },
  {
    "code": "he",
    "hash": "455f5c0d09ccd2a6158c23b136893a00",
    "name": "עברית"
  },
  {
    "code": "hi",
    "hash": "fa3c3883f143810a970ebbcf8d5a9891",
    "name": "हिन्दी"
  },
  {
    "code": "hr",
    "hash": "ff3c1ddc18a8ede7ea05188448804325",
    "name": "Hrvatski"
  },
  {
    "code": "hu",
    "hash": "3ccdebaa83fb5e715fec48651db1d86e",
    "name": "Magyar"
  },
  {
    "code": "hy",
    "hash": "af0ef4c42c4d13b56bf49f85a27bc9ed",
    "name": "Հայերեն"
  },
  {
    "code": "id",
    "hash": "b0ab2243854055b9ea73f66be53d4660",
    "name": "Indonesia"
  },
  {
    "code": "it",
    "hash": "8c1e736d6cbaa7307d0df720e05f2ea8",
    "name": "Italiano"
  },
  {
    "code": "is",
    "hash": "4bd6a2f1407956e74a74ece79a55d6b0",
    "name": "Íslenska"
  },
  {
    "code": "ja",
    "hash": "2b5b92cec0f0a5b0a75012340d7c0faa",
    "name": "日本語"
  },
  {
    "code": "ka",
    "hash": "5af785961d76db569358229418d52cb6",
    "name": "Kartuli"
  },
  {
    "code": "ko",
    "hash": "811c7aaa07c09aefe2a55341a21e844f",
    "name": "한국어"
  },
  {
    "code": "lb",
    "hash": "b389bf3d7d89bd8f3595cfb080052d03",
    "name": "Lëtzebuergesch"
  },
  {
    "code": "lt",
    "hash": "ec3675bc693854933c932edebf28ad3a",
    "name": "Lietuvių"
  },
  {
    "code": "lv",
    "hash": "e272436516b72ade32c63be53fbe0f8e",
    "name": "Latviešu"
  },
  {
    "code": "mk",
    "hash": "683584ddd277e24d703eff7b88500a40",
    "name": "Македонски"
  },
  {
    "code": "ml",
    "hash": "47e7c52f17d5462f2f34e20c4d1fb8ed",
    "name": "മലയാളം"
  },
  {
    "code": "nl",
    "hash": "b44e4be9fcc4f8aac2054096e4745800",
    "name": "Nederlands"
  },
  {
    "code": "nb",
    "hash": "83817abf88651f558ddd4dd5a13b0568",
    "name": "Norsk Bokmål"
  },
  {
    "code": "nn",
    "hash": "d059505d060777558d54f164067bbc3e",
    "name": "Norsk Nynorsk"
  },
  {
    "code": "pl",
    "hash": "666b38542cc58bcc38638a3b8f54b7b0",
    "name": "Polski"
  },
  {
    "code": "pt",
    "hash": "6a6dcc2e92ca21f95d0c96a6f8c9ffd9",
    "name": "Português"
  },
  {
    "code": "pt-BR",
    "hash": "3936613df32bef26e4d43c8e10e57964",
    "name": "Português (BR)"
  },
  {
    "code": "ro",
    "hash": "0979ced3b8898618b53d23788a2f4618",
    "name": "Română"
  },
  {
    "code": "ru",
    "hash": "cf3a476024af4bf2084cfbd7a2735249",
    "name": "Русский"
  },
  {
    "code": "sk",
    "hash": "ab41f13ae8a7e12a1c34420edb8cdfa5",
    "name": "Slovenčina"
  },
  {
    "code": "sl",
    "hash": "6b3ccd0f11df82cf75c680d9d4714277",
    "name": "Slovenščina"
  },
  {
    "code": "sr",
    "hash": "af8703dcadf10b434886b1a1ba3794fa",
    "name": "Српски"
  },
  {
    "code": "sr-Latn",
    "hash": "a3fa96f829aad8e8d50044215923ef1d",
    "name": "Srpski"
  },
  {
    "code": "sv",
    "hash": "129f3efbf453899a8113bbb263b9d031",
    "name": "Svenska"
  },
  {
    "code": "sq",
    "hash": "d9c6b057141c562baf87d0c47702f96c",
    "name": "Shqip"
  },
  {
    "code": "ta",
    "hash": "01e739303bcd977722c665a7fb63ff58",
    "name": "தமிழ்"
  },
  {
    "code": "te",
    "hash": "c87b12777023388965f6e88c3d8e5970",
    "name": "తెలుగు"
  },
  {
    "code": "th",
    "hash": "3fdcf2b75b36bb3ece1947414afcf492",
    "name": "ภาษาไทย"
  },
  {
    "code": "tr",
    "hash": "2d1166ed61fa775047a1fb9530a9368d",
    "name": "Türkçe"
  },
  {
    "code": "uk",
    "hash": "12365a6043e52d725d7904cb03f8154b",
    "name": "Українська"
  },
  {
    "code": "ur",
    "hash": "138a60bb34967385726bcef3b9622c88",
    "name": "اُردُو"
  },
  {
    "code": "vi",
    "hash": "e55a8b252ebafaa38af428aaca3f5cdd",
    "name": "Tiếng Việt"
  },
  {
    "code": "zh-Hans",
    "hash": "ca6c86cd23631a2b4f03f81631af576f",
    "name": "简体中文"
  },
  {
    "code": "zh-Hant",
    "hash": "37e304c63a253cb8dc099de9ba8a8336",
    "name": "繁體中文"
  }
] satisfies Array<{
  code: Locales;
  hash: string;
  name: string;
}>;

export const localeTranslations = locales;

export default locales.map(locale => ({
  ...locale,
  async fetch(): Promise<LocaleData> {
    const cached = CACHE[locale.code];
    if (typeof cached !== 'undefined') return cached;
    const data : {
      default: LocaleData
    } = await import(`./${locale.code}/${locale.code}.json`);
    CACHE[locale.code] = data.default;
    return data.default;
  }
}));